import { render, staticRenderFns } from "./statisticsLung.vue?vue&type=template&id=383a2f19&scoped=true"
import script from "./statisticsLung.vue?vue&type=script&lang=js"
export * from "./statisticsLung.vue?vue&type=script&lang=js"
import style0 from "./statisticsLung.vue?vue&type=style&index=0&id=383a2f19&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "383a2f19",
  null
  
)

export default component.exports